import apiClient from './basicApi'

function getHolidayStatus() {
  return apiClient.get('holidaymodus/status').then((res) => res.data)
}

export { getHolidayStatus }
